// @flow
import {addHours, subHours} from 'date-fns'

type Options = {
  databaseId?: string,
  isDeleted?: boolean,
  isNew?: boolean,
  isProtected?: boolean,
  htmlDiff?: string,
  ...
}

class Value {
  databaseId: ?string
  isDeleted: boolean
  isNew: boolean
  isProtected: boolean
  prevValue: string
  realNextValue: string
  htmlDiff: string

  constructor(
    prevValue: ?string,
    nextValue: ?string,
    {
      databaseId,
      isDeleted,
      isNew,
      isProtected,
      htmlDiff,
    }: Options = {},
  ) {
    this.databaseId = databaseId || null
    this.isDeleted = !!isDeleted
    this.isNew = !!isNew
    this.isProtected = !!isProtected
    this.prevValue = isNew ? '' : (prevValue || '')
    this.realNextValue = nextValue === '' ? nextValue : (nextValue || this.prevValue)
    this.htmlDiff = htmlDiff || ''
  }

  markDeleted(bool: boolean): Value {
    this.isDeleted = bool
    return this
  }

  get nextValue(): string {
    return this.isDeleted ? '' : this.realNextValue
  }

  get isUnchanged(): boolean {
    return this.prevValue === this.nextValue && !this.isDeleted
  }

  get isChanged(): boolean {
    return !this.isUnchanged
  }

  get isEmpty(): boolean {
    return this.nextValue === ''
  }

  setValue(value: string): Value {
    this.realNextValue = value || ''
    return this
  }

  toValidLocalDate(): Date {
    const offset = new Date().getTimezoneOffset()
    const userTimeZoneOffset = -Math.floor(offset / 60)

    const localMidDayDate = new Date(`${this.realNextValue}T12:00`)

    const correctHours = userTimeZoneOffset < 0
      ? subHours
      : addHours

    const UTCMidDayDate = correctHours(localMidDayDate, userTimeZoneOffset)

    return UTCMidDayDate
  }
}

const emptyValue = (): Value => new Value('', '', {isNew: true})
const newValue = (value: string): Value => new Value('', value, {isNew: true})

export {
  emptyValue,
  newValue,
}

export default Value
